<template>
  <filial-settings-view title="Отзывы на чеках (QR)" :keys="keys" />
</template>

<script>
  import FilialSettingsView from '@/components/ui/crud/fields/filials/FilialSettingsView.vue'
  import SettingKey from '@/models/enums/SettingKey'

  export default {
    name: 'QrFeedbackSettings',
    components: { FilialSettingsView },
    data () {
      return {
        keys: [SettingKey.CheckQrCodeLink],
      }
    },
  }
</script>
